import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React from 'react';

import { imagePropTypes, linkPropTypes } from '../../../propTypes';
import Picture from '../Picture';

const propTypes = exact({
  data: PropTypes.arrayOf(
    PropTypes.shape({
      cta: linkPropTypes,
      image: imagePropTypes,
      text: PropTypes.string,
    })
  ).isRequired,
});

function OneThirdContentBlock(props) {
  return (
    <div className="OneThirdContentBlock">
      <div className="OneThirdContentBlock_container">
        <ul className="OneThirdContentBlock_content">
          {props.data.map((item) => {
            const imageEl = (
              <div className="OneThirdContentBlock_imageContainer">
                {item.image && (
                  <Picture
                    {...item.image}
                    className="OneThirdContentBlock_image"
                    sizes={[
                      [100, 1.77], // from 0
                      [100, 1.77], // from 440
                      [50, 1.77], // from 768
                      [50, 1.77], // from 1024
                      ['517', 1.77], // from 1440
                    ]}
                  />
                )}
              </div>
            );

            return (
              <li className="OneThirdContentBlock_item" key={item.text}>
                {/* CTA card */}
                {item.cta && (
                  <a href={item.cta.url} className="OneThirdContentBlock_body">
                    {imageEl}
                    <h3 className="OneThirdContentBlock_title">{item.cta.title}</h3>
                  </a>
                )}
                {/* Image card */}
                {!item.cta && (
                  <div className="OneThirdContentBlock_body">
                    {imageEl}
                    {item.text && <h3 className="OneThirdContentBlock_title">{item.text}</h3>}
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}

OneThirdContentBlock.propTypes = propTypes;

export default OneThirdContentBlock;
